// Excludes easily-confused chars (l, o, 0, 1) — matches the legacy RoomUI alphabet.
export const ROOM_ID_ALPHABET = "abcdefghijkmnpqrstuvwxyz23456789";

/** A short, URL-safe, crypto-random room id (5 chars). */
export function generateRoomId(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(5));
  return Array.from(bytes, (b) => ROOM_ID_ALPHABET[b % ROOM_ID_ALPHABET.length]).join("");
}

/** Build a shareable room link from a base href: keeps origin+path, sets ?room=, drops the rest. */
export function roomLinkFor(roomId: string, href: string): string {
  const u = new URL(href);
  u.search = `?room=${encodeURIComponent(roomId)}`;
  u.hash = "";
  return u.toString();
}
